import React from 'react';
import {
  bool,
  oneOfType,
  element,
  arrayOf,
} from 'prop-types';
import { Fade, Grid } from '@material-ui/core';

const FormPage = ({ isVisible, children }) => {
  return (
    <Fade in={isVisible} timeout={{ enter: 300, exit: 0 }}>
      <Grid
        container
        item
        direction="column"
        style={{
          position: isVisible ? 'relative' : 'absolute',
        }}
      >
        {children}
      </Grid>
    </Fade>
  );
};

FormPage.propTypes = {
  isVisible: bool,
  children: oneOfType([element, arrayOf(element)]),
};

export default FormPage;
